// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchInput_wrapper__WmzYr","icon":"SearchInput_icon__4S3uc","input":"SearchInput_input__pvo3q","clearBtn":"SearchInput_clearBtn__Exkwe"};